import { GetLatestChaptersRequest, type GetLatestChaptersResponse } from '@app/_proto/Protos/chapters';
import { ChaptersClient } from '@app/_proto/Protos/chapters.client';
import { PageInfoRequest } from '@app/_proto/Protos/pagination';
import { useGrpcApiWithQuery } from '@app/libs/api';
import { useGrpcRequest } from '@app/libs/grpc';
import type { PartialMessage } from '@protobuf-ts/runtime';

type UseLatestChaptersParam = {
    requestOption?: PartialMessage<GetLatestChaptersRequest>;
    enabled?: boolean;
    cacheTime?: number;
    staleTime?: number;
};
type UseLatestChaptersReturn = {
    data?: GetLatestChaptersResponse;
    isLoading: boolean;
};

export default function useLatestChapters({
    requestOption = {},
    enabled = false,
    cacheTime = MINUTE_MS * 60 * 24, // 24 hours cache
    staleTime = MINUTE_MS * 5, //Data stales in 5 minutes
}: UseLatestChaptersParam = {}): UseLatestChaptersReturn {
    const latestChaptersRequest = useGrpcRequest(GetLatestChaptersRequest, {
        pageInfo: PageInfoRequest.create(LATEST_CHAPTERS_PAGE_QUERY_PARAMS),
        ...requestOption,
    });
    const { data, isLoading } = useGrpcApiWithQuery(
        ChaptersClient,
        c => c.getLatestChapters,
        latestChaptersRequest,
        ['latest-chapters', LATEST_CHAPTERS_PAGE_QUERY_PARAMS.count],
        {
            enabled,
            cacheTime,
            staleTime,
        }
    );

    return { data, isLoading };
}

const LATEST_CHAPTERS_PAGE_QUERY_PARAMS = {
    page: 1,
    count: 45,
};

const MINUTE_MS = 1000 * 60;
